import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Tooltip } from "react-tooltip";

const Courses = (props) => {
  const [courses, setCourses] = useState(props.courses);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const fetchCourses = (search) => {
    let url = "/courses?";
    if (search) {
      url += `search=${search}`;
    }

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setCourses(data.courses);
      });
  };

  useEffect(() => {
    fetchCourses(debouncedSearch);
  }, [debouncedSearch]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [search, 500]);

  const courseClass = (expired) => {
    let classes =
      "w-full border flex flex-col border-gray-200 overflow-hidden relative rounded-lg shadow-sm hover:shadow-md transition-shadow";
    if (expired) {
      classes += "pointer-events-none opacity-60 border-primaryYellow";
    }
    return classes;
  };

  const hrefClass = (expired) => {
    let classes = "";
    if (expired) {
      classes += "pointer-events-none";
    }
    return classes;
  };

  console.log(courses);

  const coursesCards = courses.map((course) => {
    return (
      <div
        key={course.id}
        className={courseClass(course.expired)}
        data-tooltip-id={course.id}
        data-tooltip-html="Termin ukończenia kursu minął.<br/>Skontaktuj się z administratorem szkolenia w celu uzyskania dalszych informacji."
      >
        <a
          href={`/client/courses/${course.id}`}
          className={hrefClass(course.expired)}
        >
          {!course.logo_url ? (
            <div className="mb-4 w-full h-48 flex items-center justify-center border-gray-100 border-2 text-gray-500 bg-gray-50">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="size-8"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                />
              </svg>
            </div>
          ) : (
            <div className="mb-4 w-full h-48 border-gray-100 border-2 overflow-hidden bg-gray-50">
              <img
                className="w-full h-full object-contain"
                src={course.logo_url}
                alt={`${course.title} logo`}
              />
            </div>
          )}
        </a>

        <div className="p-4">
          <h3 className="font-semibold text-lg mb-1">{course.title}</h3>
          <p className="text-sm text-gray-700 mb-2">{course.description}</p>
          <div className="flex gap-2 text-xs mb-2">
            {course.categories.map((category) => (
              <span
                key={category.id}
                className="border-2 border-gray-100 px-2 py-0.5 text-gray-500"
              >
                {category.name}
              </span>
            ))}
          </div>
          <div className="text-right text-xs text-gray-500">
            {course.completed_at
              ? `Ukończono: ${course.completed_at}`
              : course.started
                ? "W trakcie"
                : "Rozpocznij szkolenie"}
          </div>
        </div>
      </div>
    );
  });

  return (
    <div className="max-h-[85vh] flex h-screen">
      {courses.map((course) =>
        course.expired ? <Tooltip key={course.id} id={course.id} /> : null,
      )}
      <div className="flex-1 p-2 overflow-y-auto">
        <div className="relative mb-10">
          <input
            type="text"
            placeholder="Wyszukaj szkolenie..."
            className="pl-10 w-full p-2 border border-gray-300"
            onChange={(e) => setSearch(e.target.value)}
          />

          <svg
            className="w-4 h-4 absolute left-2.5 top-3.5 text-gray-400"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            viewBox="0 0 24 24"
          >
            <path d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1010.5 18a7.5 7.5 0 006.15-3.35z" />
          </svg>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 auto-rows-max">
          {coursesCards}
        </div>
      </div>
    </div>
  );
};

Courses.propTypes = {
  clients: PropTypes.array,
  courses: PropTypes.array,
  categories: PropTypes.array,
};

export default Courses;
